import styled from 'styled-components';

const InputError = styled.div`
  color: ${p => p.theme.colors.danger};
`;

export default InputError;
